import type { Message, EnrichedMessage } from "./types";

function formatDate(date: Date): string {
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
}

function isSameDay(date1: Date, date2: Date): boolean {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}

export function transformMessages(messages: Message[]): EnrichedMessage[] {
  const enriched: EnrichedMessage[] = [];
  let previousDate: Date | null = null;

  for (const message of messages) {
    const messageDate = new Date(message.createdAt);

    if (!previousDate || !isSameDay(previousDate, messageDate)) {
      enriched.push({
        ...message,
        showDateSeparator: true,
        dateSeparatorText: formatDate(messageDate),
      });
      previousDate = messageDate;
    } else {
      enriched.push({
        ...message,
        showDateSeparator: false,
      });
    }
  }

  return enriched;
}
